<template>
  <div :style="standalone ? 'margin:5px' : 'margin:20px'">
    <FiPageRail v-if="!standalone" title="VSM Upcoming" :class="{ 'vsm-upcoming-rail--mobile': mobileView }">
      <template #actions>
        <b-button v-if="!mobileView" variant="success" size="sm" @click="view_more_info = !view_more_info" aria-label="more info">
          <i class="fa fa-info-circle"></i>
        </b-button>
      </template>
    </FiPageRail>

    <b-modal title="VSM Upcoming Standalone Mode" size="lg" v-model="view_more_info" ok-only>
      &nbsp;&nbsp;provides a standalone view that refreshes every minute to keep all teams in sync (no login required)
      <br/>&nbsp;&nbsp;<a target="_blank" :href="standalone_href">click here to load this view</a><vsm-standalone-url-copy-button :href="standalone_href" :tenant-id="tenant_id"/>
      <span v-if="base_options && base_options.length > 2">
        <br/><br/>&nbsp;&nbsp;Click on a base name to load the view specific to that base.<br/>
        <template v-for="base in base_options">
          <span v-if="base.value != ''" :key="'sa-base-' + base.value">
            <br/>&nbsp;&nbsp;&nbsp;<a target="_blank" :href="standalone_href + '/' + base.value">{{ base.value }}</a><vsm-standalone-url-copy-button :href="standalone_href + '/' + base.value" :tenant-id="tenant_id"/>
          </span>
        </template>
      </span>
    </b-modal>

    <div v-if="standalone">
      <span class="vsm-standalone-header" style="font-size: 20px;">
        <a target="_new" href="https://www.initekconsulting.com/fleet-integrations"><img style="margin-top:-5px" width="40" src="favicon.ico"/></a>&nbsp;VSM Upcoming<span v-if="summary && summary.tenant_name"> - {{summary.tenant_name}}</span> {{selected_base}}&nbsp;
        <b-spinner v-if="reloading" style="width: 1.8rem; height: 1.8rem"></b-spinner><span v-else style="width: 1.8rem; height: 1.8rem">&nbsp;</span>
        &nbsp;<vsm-reload-button @click="load_data()" />
      </span>
    </div>

    <div v-if="summary && summary.base_warning" class="vsm-unknown-base">
      {{summary.base_warning}}
    </div>

    <div class="actuals-tbn-toolbar vsm-upcoming-toolbar" :class="{ 'vsm-upcoming-toolbar--standalone': standalone }">
      <b-button-group size="sm" class="driver-actuals-timeframe">
        <b-button
          v-for="opt in timeframe_options"
          :key="opt.value"
          :variant="timeframeDays === opt.value ? 'primary' : 'outline-secondary'"
          v-on:click.prevent="set_timeframe(opt.value)"
        >{{ opt.label }}</b-button>
      </b-button-group>
      <b-form-select size="sm" v-if="!standalone && base_options && base_options.length > 2" v-model="selected_base" :options="base_options" class="toolbar-select toolbar-base"/>
      <span v-if="!standalone" class="toolbar-group">
        <span class="toolbar-label">Filter</span>
        <b-form-input size="sm" class="toolbar-input" v-model="booking_filter" placeholder=""/>
      </span>
      <template v-if="!loading && has_run">
        <span class="vsm-upcoming-chip total" @click="clear_status_filters()">Total ({{ vehicles.length }})</span>
        <span class="toolbar-label">Wash</span>
        <template v-if="!show_maint">
          <span v-if="washed_enabled" class="vsm-upcoming-chip ready" :class="{ selected: selected_wash_statuses.includes('READY') }" @click="toggle_wash_status('READY')">Ready ({{ status_count('READY') }})</span>
          <span class="vsm-upcoming-chip cleaned" :class="{ selected: selected_wash_statuses.includes('CLEANED') }" @click="toggle_wash_status('CLEANED')">Clean ({{ status_count('CLEANED') }})</span>
          <span v-if="washed_enabled" class="vsm-upcoming-chip washed" :class="{ selected: selected_wash_statuses.includes('WASHED') }" @click="toggle_wash_status('WASHED')">Washed ({{ status_count('WASHED') }})</span>
          <span class="vsm-upcoming-chip dirty" :class="{ selected: selected_wash_statuses.includes('DIRTY') }" @click="toggle_wash_status('DIRTY')">Dirty ({{ status_count('DIRTY') }})</span>
          <span class="vsm-upcoming-chip out" :class="{ selected: selected_wash_statuses.includes('OUT') }" @click="toggle_wash_status('OUT')">Out ({{ status_count('OUT') }})</span>
          <span class="vsm-upcoming-chip oos" :class="{ selected: selected_wash_statuses.includes('OOS') }" @click="toggle_wash_status('OOS')">OOS ({{ status_count('OOS') }})</span>
        </template>
        <template v-else>
          <span class="vsm-upcoming-chip cleaned" :class="{ selected: selected_wash_statuses.includes('CLEANED') }" @click="toggle_wash_status('CLEANED')">Clean ({{ status_count('CLEANED') }})</span>
          <span class="vsm-upcoming-chip dirty" :class="{ selected: selected_wash_statuses.includes('DIRTY') }" @click="toggle_wash_status('DIRTY')">Dirty ({{ status_count('DIRTY') }})</span>
          <span class="vsm-upcoming-chip out" :class="{ selected: selected_wash_statuses.includes('OUT') }" @click="toggle_wash_status('OUT')">Out ({{ status_count('OUT') }})</span>
          <span class="toolbar-label">Maint</span>
          <span class="vsm-upcoming-chip ready" :class="{ selected: selected_maint_statuses.includes('READY') }" @click="toggle_maint_status('READY')">Ready ({{ maint_count('READY') }})</span>
          <template v-if="vsm_mode === 'dvir'">
            <span v-if="dvir_combined" class="vsm-upcoming-chip dvir" :class="{ selected: selected_maint_statuses.includes('DVIR') }" @click="toggle_maint_status('DVIR')">DVIR ({{ maint_count('DVIR') }})</span>
            <template v-else>
              <span class="vsm-upcoming-chip dvir" :class="{ selected: selected_maint_statuses.includes('PENDING_DVIR') }" @click="toggle_maint_status('PENDING_DVIR')">Pending ({{ maint_count('PENDING_DVIR') }})</span>
              <span class="vsm-upcoming-chip unsafe-dvir" :class="{ selected: selected_maint_statuses.includes('UNSAFE_DVIR') }" @click="toggle_maint_status('UNSAFE_DVIR')">Unsafe ({{ maint_count('UNSAFE_DVIR') }})</span>
            </template>
          </template>
          <span class="vsm-upcoming-chip pm" :class="{ selected: selected_maint_statuses.includes('PM') }" @click="toggle_maint_status('PM')">PM ({{ maint_count('PM') }})</span>
          <span class="vsm-upcoming-chip oos" :class="{ selected: selected_maint_statuses.includes('OOS') }" @click="toggle_maint_status('OOS')">OOS ({{ maint_count('OOS') }})</span>
        </template>
        <span class="vsm-upcoming-chip overlap" :class="{ selected: show_overlaps_only }" @click="toggle_overlaps()" title="Vehicles with overlapping schedule bars">Overlaps ({{ overlap_count }})</span>
      </template>
    </div>

    <div v-if="loading" class="text-center my-4">
      <b-spinner class="align-middle"/>
    </div>

    <!-- phones get cards instead of the timeline grid (vsm_board pattern:
         a v-if swap, the table DOM never renders on mobile) -->
    <div v-else-if="has_run && cardView" class="vsm-up-card-list">
      <div v-for="{ row, departure } in card_rows" :key="'card-' + row.vehicle" class="vsm-up-card">
        <div class="vsm-up-card-head">
          <span class="vsm-up-card-vehicle">{{ row.vehicle_label }}</span>
          <b-form-select
            v-if="can_edit_wash_status && row.has_vehicle_info && !standalone"
            v-model="row.vehicle_status"
            :options="visible_status_options"
            size="sm"
            class="vsm-up-chip-select"
            :class="statusCellClass(row.vehicle_status)"
            @change="update_wash_status(row)"
          />
          <span v-else-if="row.vehicle_status" class="vsm-up-mini-chip" :class="statusCellClass(row.vehicle_status)">{{ row.vehicle_status }}</span>
          <template v-if="show_maint">
            <b-form-select
              v-if="can_edit_maint_status && row.has_vehicle_info && !standalone && !maintLocked(row.maintenance_status)"
              :value="maint_select_value(row.maintenance_status)"
              :options="maintenance_status_options"
              size="sm"
              class="vsm-up-chip-select"
              :class="maintCellClass(row.maintenance_status)"
              @change="update_maint_status(row, $event)"
            />
            <span v-else-if="row.maintenance_status" class="vsm-up-mini-chip" :class="maintCellClass(row.maintenance_status)">{{ display_maint_status(row.maintenance_status) }}</span>
          </template>
          <span v-if="departure" class="vsm-up-card-depart">
            <span class="vsm-up-card-depart-delta">in {{ departure.delta }}</span>
            <span class="vsm-up-card-depart-time">{{ departure.time }}</span>
          </span>
        </div>
        <div
          v-for="item in cardSegments(row)"
          :key="'seg-' + item.seg.booking_id + '-' + item.seg.start_datetime"
          class="vsm-up-card-item"
          :class="{ 'vsm-up-card-item--service': item.seg.is_service_event, 'vsm-up-card-item--overlap': item.overlap }"
        >
          <span class="vsm-up-card-time">{{ fmt_time(item.seg.start_datetime) }} &rarr; {{ fmt_time(item.seg.end_datetime) }}</span>
          <template v-if="item.seg.is_service_event">
            <span>{{ item.seg.booking.event_type || 'Maintenance' }}</span>
            <span v-if="item.seg.booking.comment" class="vsm-up-card-meta">{{ item.seg.booking.comment }}</span>
          </template>
          <template v-else>
            <span>{{ item.seg.booking.bookingID }}</span>
            <span v-if="item.seg.booking.driver" class="vsm-up-card-meta">{{ item.seg.booking.driver }}</span>
            <span v-if="item.seg.booking.routeDescription" class="vsm-up-card-meta">{{ item.seg.booking.routeDescription }}</span>
          </template>
        </div>
      </div>
      <div v-if="!timeline_display_rows.length" class="text-center text-muted py-4">No bookings found for this search.</div>
    </div>

    <driver-actuals-timeline-table
      v-else-if="has_run"
      resource-type="vehicle"
      :rows="timeline_display_rows"
      :leading-columns="leading_columns"
      :fit-width="timeframeDays >= 3"
      :show-now-line="true"
      :timeline-days="timelineDays"
      :timeline-slots="timeline_slots"
      :timeline-slots-per-day="timelineSlotsPerDay"
      @cell-hover="onTimelineCellHover"
      @cell-leave="onTimelineCellLeave"
      @cell-click="onTimelineCellClick"
    >
      <template #leading-cell="{ row }">
        <b-form-select
          v-if="can_edit_wash_status && row.has_vehicle_info && !standalone"
          v-model="row.vehicle_status"
          :options="visible_status_options"
          size="sm"
          class="vsm-up-chip-select"
          :class="statusCellClass(row.vehicle_status)"
          @change="update_wash_status(row)"
        />
        <span v-else-if="row.vehicle_status" class="vsm-up-mini-chip" :class="statusCellClass(row.vehicle_status)">{{ row.vehicle_status }}</span>
        <template v-if="show_maint">
          <b-form-select
            v-if="can_edit_maint_status && row.has_vehicle_info && !standalone && !maintLocked(row.maintenance_status)"
            :value="maint_select_value(row.maintenance_status)"
            :options="maintenance_status_options"
            size="sm"
            class="vsm-up-chip-select"
            :class="maintCellClass(row.maintenance_status)"
            @change="update_maint_status(row, $event)"
          />
          <span v-else-if="row.maintenance_status" class="vsm-up-mini-chip" :class="maintCellClass(row.maintenance_status)">{{ display_maint_status(row.maintenance_status) }}</span>
        </template>
      </template>
    </driver-actuals-timeline-table>

    <driver-actuals-booking-panel
      :visible="booking_panel_visible"
      :details="booking_panel_details"
      :panel-style="booking_panel_style"
      variant="tbn"
      resource-type="vehicle"
      header-label="Details"
      :left-align-labels="true"
      @panel-enter="onBookingPanelEnter"
      @panel-leave="onBookingPanelLeave"
    />

    <!-- click-on-a-bar modal: same detail content as the hover panel -->
    <b-modal v-model="booking_modal_visible" title="Booking Details" ok-only size="md">
      <div v-if="booking_modal_loading" class="text-center mb-2">
        <b-spinner small label="Loading complete details"/>
      </div>
      <driver-actuals-booking-panel
        inline
        :visible="true"
        :details="booking_modal_details"
        variant="tbn"
        resource-type="vehicle"
        header-label="Details"
        :left-align-labels="true"
      />
    </b-modal>
  </div>
</template>

<script>
import driverActualsUtilHover from '@/mixins/vehicle_actuals_util_hover'
import vsmMobileView from '@/mixins/vsm_mobile_view'
import DriverActualsTimelineTable from '@/components/driver_actuals_timeline_table.vue'
import VsmReloadButton from '@/components/VsmReloadButton.vue'
import VsmStandaloneUrlCopyButton from '@/components/VsmStandaloneUrlCopyButton.vue'
import { prepareTimelineDisplayRows } from '@/helpers/actuals_timeline_cache'
import { mapState } from 'vuex'
import moment from 'moment'
import { justDate } from '@/helpers/dates'
import { getTbnVehicleStartEnd } from '@/helpers/vehicle_actuals_times'
import { displayMaintStatus, maintStatusSelectValue } from '@/utils/vsm_fields'
import { get_tbn_actuals, get_tbn_vsm_upcoming, tbn_update_vehicle_status } from '../networking/tbn_apis'
import {
  DRIVER_ACTUALS_SLOTS_PER_DAY,
  DRIVER_ACTUALS_TIMELINE_SLOTS,
  DRIVER_ACTUALS_TIMEFRAME_OPTIONS,
  bookingOverlapsDateRange,
  buildVehicleTimelineRowsMerged,
  enrichVehicleDisplayRows,
  getCellBarClassesWithOverlapPattern,
  getSegmentsAtCell,
  getTimelineDays,
  getTimelineEndDate,
  segmentsOverlapByMinute,
} from '@/helpers/vehicle_actuals_timeline'

export default {
  name: 'vehicle_status_upcoming_tbn',

  mixins: [driverActualsUtilHover, vsmMobileView],

  components: {
    DriverActualsTimelineTable,
    VsmReloadButton,
    VsmStandaloneUrlCopyButton,
  },

  data() {
    return {
      items: [],
      items_full: [],
      vehicles: [],
      timeline_display_rows: [],
      summary: {},
      loading: false,
      has_run: false,
      standalone: false,
      tenant_id: null,
      view_more_info: false,
      reloading: false,
      reload_mode: 0,
      timer: null,
      washed_enabled: false,
      selected_base: '',
      base_options: [],
      selected_wash_statuses: [],
      selected_maint_statuses: [],
      show_overlaps_only: false,
      overlap_count: 0,
      selectedDate: justDate(moment()),
      timeframeDays: 3,
      booking_filter: '',
      timeline_slots: DRIVER_ACTUALS_TIMELINE_SLOTS,
    }
  },

  async created() {
    this.check_features()
  },

  beforeDestroy() {
    this.stopTimer()
  },

  methods: {
    check_features() {
      // /vsm-upcoming-tbn/reload/<tenantIdOrUuid>[/<base>] renders the
      // chromeless auto-refreshing wall board (no login; App.vue exempts /vsm*)
      if (this.$route.path.indexOf('/vsm-upcoming-tbn/reload/') !== -1) {
        this.standalone = true
        const filter = this.$route.path.split('/vsm-upcoming-tbn/reload/')[1] || ''
        if (filter.indexOf('/') !== -1) {
          this.tenant_id = filter.split('/')[0]
          this.selected_base = decodeURIComponent(filter.split('/')[1])
        } else {
          this.tenant_id = filter
        }
        this.reload_mode = 60000
        this.load_data()
        return
      }
      this.standalone = false
      this.reload_mode = 0
      this.maybeAutoSearch()
    },
    maybeAutoSearch() {
      if (!this.user || !this.user.tenant)
        return
      this.tenant_id = this.user.tenant
      if (this.loading || this.has_run)
        return
      this.load_data()
    },
    startTimer() {
      this.stopTimer()
      if (this.reload_mode > 0)
        this.timer = setInterval(() => this.reload_data(), this.reload_mode)
    },
    stopTimer() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    async resetTimerAndReload() {
      this.stopTimer()
      await this.reload_data()
      this.startTimer()
    },
    async reload_data() {
      if (this.reloading)
        return
      if (this.$pageVisibility && this.$pageVisibility.hidden)
        return
      await this.run_fetch(true, false)
    },
    // PENDING/UNSAFE dvir statuses are system-written; process_vehicle_status
    // would flip a manual change back within ~10 minutes
    maintLocked(status) {
      return status === 'PENDING_DVIR' || status === 'UNSAFE_DVIR'
    },
    bookingDetailVariant() {
      return 'tbn'
    },
    bookingDetailPlannedOnly() {
      return true
    },
    bookingDetailActualsPath() {
      // standalone boards are no-login; the actuals page needs a session
      return this.standalone ? null : '/actuals_tbn'
    },
    // click modal: pull the complete actuals-page records for the clicked
    // booking(s); standalone has no session for the actuals endpoint
    async fetchBookingModalRecords(segments) {
      if (this.standalone)
        return null
      const refs = [...new Set(segments
        .map(seg => seg.booking && !seg.booking.is_service_event && (seg.booking.tbn_booking_hash || seg.booking.bookingID))
        .filter(Boolean))]
      const records = []
      for (const ref of refs) {
        const { value: { data = {} } } = await get_tbn_actuals(this.tenant_id, '', ref, '', '', '')
        records.push(...(data.results || []))
      }
      return records
    },
    set_timeframe(days) {
      if (this.timeframeDays === days)
        return
      this.timeframeDays = days
      this.load_data()
    },
    selectedDateApi() {
      return moment(this.selectedDate, 'MM-DD-YYYY').format('YYYY-MM-DD')
    },
    contains(val1, val2) {
      if (val1 != null)
        return String(val1).toLowerCase().indexOf(val2.toLowerCase()) !== -1
      return false
    },
    itemOverlapsTimeframe(item) {
      const { start, end } = getTbnVehicleStartEnd(item)
      return bookingOverlapsDateRange(start, end, this.selectedDate, this.timeframeDays)
    },
    async load_data(isRetry) {
      await this.run_fetch(false, isRetry)
    },
    async run_fetch(quiet, isRetry) {
      // quiet = standalone auto-refresh: small header spinner, no page swap
      if (quiet)
        this.reloading = true
      else
        this.loading = true
      // the page has no date picker: every load re-anchors the range to today
      // (tenant timezone once known; the very first load may only have the
      // browser timezone and re-requests below if the dates disagree)
      this.selectedDate = justDate(moment())
      const requestSeq = (this._loadSeq || 0) + 1
      this._loadSeq = requestSeq
      try {
        const fromDate = this.selectedDateApi()
        const toDate = getTimelineEndDate(this.selectedDate, this.timeframeDays)
        const { value: { data = {} } } = await get_tbn_vsm_upcoming(
          this.tenant_id,
          this.selected_base,
          fromDate,
          toDate
        )
        // a newer request (timeframe/base click) superseded this one
        if (requestSeq !== this._loadSeq)
          return
        this.summary = data.summary || {}
        if (this.summary.timezone) {
          moment.tz.setDefault(this.summary.timezone)
          if (!isRetry && justDate(moment()) !== this.selectedDate)
            return this.run_fetch(quiet, true)
        }
        this.washed_enabled = !!this.summary.washed_enabled
        if (this.summary.bases)
          this.base_options = this.summary.bases
        this.vehicles = (data.vehicles || []).slice().sort((a, b) => String(a.name).localeCompare(String(b.name)))
        this.items_full = (data.results || []).concat(data.service_events || [])
        this.filter_results()
        this.has_run = true
      } catch (e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }
      // (re)arm outside the try so a failed fetch still retries in a minute
      if (this.standalone && this.reload_mode > 0)
        this.startTimer()
      if (requestSeq === this._loadSeq) {
        this.loading = false
        this.reloading = false
      }
    },
    toggle_wash_status(status) {
      if (this.selected_wash_statuses.includes(status))
        this.selected_wash_statuses = this.selected_wash_statuses.filter(s => s !== status)
      else
        this.selected_wash_statuses = [...this.selected_wash_statuses, status]
      this.filter_results()
    },
    toggle_maint_status(status) {
      if (this.selected_maint_statuses.includes(status))
        this.selected_maint_statuses = this.selected_maint_statuses.filter(s => s !== status)
      else
        this.selected_maint_statuses = [...this.selected_maint_statuses, status]
      this.filter_results()
    },
    clear_status_filters() {
      this.selected_wash_statuses = []
      this.selected_maint_statuses = []
      this.show_overlaps_only = false
      this.filter_results()
    },
    toggle_overlaps() {
      this.show_overlaps_only = !this.show_overlaps_only
      this.filter_results()
    },
    computeOverlapVehicles(items) {
      const names = new Set()
      const rows = buildVehicleTimelineRowsMerged(items, booking => getTbnVehicleStartEnd(booking), 'bookingID')
      for (const row of rows) {
        const segments = row.segments || []
        for (let i = 0; i < segments.length && !names.has(row.vehicle); i++) {
          for (let j = i + 1; j < segments.length; j++) {
            if (segmentsOverlapByMinute(segments[i], segments[j])) {
              names.add(row.vehicle)
              break
            }
          }
        }
      }
      return names
    },
    status_count(status) {
      return this.vehicles.filter(v => v.vehicle_status === status).length
    },
    maint_count(status) {
      if (status === 'DVIR')
        return this.vehicles.filter(v => v.maintenance_status === 'PENDING_DVIR' || v.maintenance_status === 'UNSAFE_DVIR').length
      return this.vehicles.filter(v => v.maintenance_status === status).length
    },
    maintStatusMatchesFilter(vehicle) {
      if (!this.selected_maint_statuses.length)
        return true
      const status = vehicle.maintenance_status
      for (const selected of this.selected_maint_statuses) {
        if (selected === 'DVIR' && (status === 'PENDING_DVIR' || status === 'UNSAFE_DVIR'))
          return true
        if (status === selected)
          return true
      }
      return false
    },
    vehicleMatchesStatusFilters(vehicle) {
      if (this.selected_wash_statuses.length && !this.selected_wash_statuses.includes(vehicle.vehicle_status))
        return false
      return this.maintStatusMatchesFilter(vehicle)
    },
    display_maint_status(status) {
      return displayMaintStatus(status, this.dvir_combined)
    },
    maint_select_value(status) {
      return maintStatusSelectValue(status, this.dvir_combined)
    },
    async update_wash_status(row) {
      await this.save_status_field(row, 'vehicle_status', row.vehicle_status)
    },
    async update_maint_status(row, value) {
      row.maintenance_status = value
      await this.save_status_field(row, 'maintenance_status', value)
    },
    async save_status_field(row, field, value) {
      // write to the source-of-truth list before the PATCH so a rebuild
      // (filter debounce, chip toggle) mid-flight keeps the edited value
      const vehicle = this.vehicles.find(v => v.name === row.vehicle)
      if (vehicle)
        vehicle[field] = value
      try {
        const json = { name: row.vehicle }
        json[field] = value
        const { value: { data = {} } } = await tbn_update_vehicle_status(this.tenant_id, json)
        // the backend can promote CLEANED+WASHED to READY
        if (vehicle && data && data.vehicle_status) {
          vehicle.vehicle_status = data.vehicle_status
          row.vehicle_status = data.vehicle_status
        }
      } catch (e) {
        this.$emit('showAlert', 'error updating data, try logging in again or contact support if needed', 'danger', 5000)
      }
    },
    itemMatchesTextFilter(item) {
      if (!this.booking_filter)
        return true
      const val = this.booking_filter
      return this.contains(item.bookingID, val)
        || this.contains(item.driver, val)
        || this.contains(item.vehicle, val)
        || this.contains(item.routeDescription, val)
        || this.contains(item.event_type, val)
    },
    filter_results() {
      // overlap membership comes from every in-range item, unfiltered, so
      // the chip count stays stable while other filters are applied
      const inRangeAll = (this.items_full || []).filter(item => this.itemOverlapsTimeframe(item))
      this._overlap_vehicle_names = this.computeOverlapVehicles(inRangeAll)
      this.overlap_count = this._overlap_vehicle_names.size

      const items = (this.items_full || []).filter(item => this.itemMatchesTextFilter(item))

      const itemVehicles = new Set(items.map(item => (item.vehicle || '').trim()).filter(Boolean))
      const infoNames = new Set(this.vehicles.map(v => v.name))
      const hasStatusFilters = this.selected_wash_statuses.length > 0 || this.selected_maint_statuses.length > 0

      const visibleNames = new Set()
      for (const vehicle of this.vehicles) {
        if (!this.vehicleMatchesStatusFilters(vehicle))
          continue
        if (this.booking_filter && !this.contains(vehicle.name, this.booking_filter) && !itemVehicles.has(vehicle.name))
          continue
        visibleNames.add(vehicle.name)
      }
      // vehicles that only exist on bookings (no VSM record) have no status to filter on
      if (!hasStatusFilters) {
        for (const name of itemVehicles) {
          if (!infoNames.has(name))
            visibleNames.add(name)
        }
      }

      if (this.show_overlaps_only) {
        for (const name of [...visibleNames]) {
          if (!this._overlap_vehicle_names.has(name))
            visibleNames.delete(name)
        }
      }

      this.visible_vehicle_names = visibleNames
      this.items = items.filter(item => visibleNames.has((item.vehicle || '').trim()))
      this.rebuildVehicleRows()
    },
    rebuildVehicleRows() {
      const inRange = this.items.filter(item => this.itemOverlapsTimeframe(item))
      const rows = buildVehicleTimelineRowsMerged(inRange, booking => getTbnVehicleStartEnd(booking), 'bookingID')
      const merged = this.mergeRowsWithVehicles(rows)
      const timelineDays = getTimelineDays(this.selectedDate, this.timeframeDays)
      this.timeline_display_rows = prepareTimelineDisplayRows(merged, enrichVehicleDisplayRows, timelineDays, {
        getCellBarClasses: getCellBarClassesWithOverlapPattern,
        getSegmentsAtCell,
      })
    },
    nextDepartureMs(group) {
      // earliest booking start still in the future: soonest upcoming
      // departure first; vehicles with none (idle or already mid-booking)
      // fall to the bottom alphabetically
      const nowMs = Date.now()
      let best = Infinity
      for (const row of group || []) {
        const segments = row.row_type === 'merged' && row.segments ? row.segments : [row]
        for (const seg of segments) {
          if (!seg || seg.is_service_event || !seg.start_datetime)
            continue
          const startMs = new Date(seg.start_datetime).getTime()
          if (startMs < nowMs)
            continue
          if (startMs < best)
            best = startMs
        }
      }
      return best
    },
    mergeRowsWithVehicles(rows) {
      const rowsByVehicle = new Map()
      for (const row of rows) {
        if (!rowsByVehicle.has(row.vehicle))
          rowsByVehicle.set(row.vehicle, [])
        rowsByVehicle.get(row.vehicle).push(row)
      }

      // only vehicles with bookings/events in range get a row
      const infoByName = new Map(this.vehicles.map(v => [v.name, v]))
      const names = new Set(rowsByVehicle.keys())

      const departureByName = new Map()
      for (const name of names)
        departureByName.set(name, this.nextDepartureMs(rowsByVehicle.get(name)))

      const merged = []
      const sortedNames = [...names].sort((a, b) => {
        const departureDelta = departureByName.get(a) - departureByName.get(b)
        if (departureDelta)
          return departureDelta
        return String(a).localeCompare(String(b))
      })
      for (const name of sortedNames) {
        const info = infoByName.get(name)
        const group = rowsByVehicle.get(name)
        for (const row of group) {
          // rows without a VSM record stay read-only: saving a status for an
          // unknown name would create a phantom vehicle-info record
          row.has_vehicle_info = !!info
          row.vehicle_status = info ? info.vehicle_status : null
          row.maintenance_status = info ? info.maintenance_status : null
          merged.push(row)
        }
      }
      return merged
    },
    scheduleFilterResultsLocal() {
      if (this._filterDebounceTimer)
        clearTimeout(this._filterDebounceTimer)
      this._filterDebounceTimer = setTimeout(() => {
        this._filterDebounceTimer = null
        this.filter_results()
      }, 250)
    },
    flag_enabled(value) {
      return !!value && String(value).toLowerCase() !== 'false'
    },
    cardSegments(row) {
      const segments = row.segments || []
      return segments.map(seg => ({
        seg,
        overlap: segments.some(other => other !== seg && segmentsOverlapByMinute(seg, other)),
      }))
    },
    cardNextDeparture(row) {
      const nowMs = Date.now()
      let best = null
      for (const seg of row.segments || []) {
        if (!seg || seg.is_service_event || !seg.start_datetime)
          continue
        const startMs = new Date(seg.start_datetime).getTime()
        if (startMs < nowMs)
          continue
        if (!best || startMs < best.ms)
          best = { ms: startMs, start: seg.start_datetime }
      }
      if (!best)
        return null
      return { time: this.fmt_time(best.start), delta: this.fmt_delta(best.ms - nowMs) }
    },
    fmt_delta(ms) {
      const mins = Math.round(ms / 60000)
      if (mins >= 1440)
        return Math.floor(mins / 1440) + 'd ' + Math.floor((mins % 1440) / 60) + 'h'
      if (mins >= 60)
        return Math.floor(mins / 60) + 'h ' + (mins % 60) + 'm'
      return mins + 'm'
    },
    fmt_time(value) {
      if (!value)
        return ''
      return moment(value).format((this.summary && this.summary.datetime_format) || 'MM/DD hh:mm A')
    },
    statusCellClass(status) {
      return status ? 'vsm-up-cell-' + String(status).toLowerCase() : null
    },
    maintCellClass(status) {
      return status ? 'vsm-up-cell-maint-' + String(status).toLowerCase() : null
    },
  },

  computed: {
    ...mapState({
      user: state => state.profile.user,
    }),
    timeframe_options() {
      return DRIVER_ACTUALS_TIMEFRAME_OPTIONS
    },
    timelineDays() {
      return getTimelineDays(this.selectedDate, this.timeframeDays)
    },
    timelineSlotsPerDay() {
      return DRIVER_ACTUALS_SLOTS_PER_DAY
    },
    // mirror vsmRouteName's mode priority: dvir, then maint, then the basic page
    vsm_mode() {
      if (this.flag_enabled(this.summary.dvir_enabled))
        return 'dvir'
      if (this.flag_enabled(this.summary.maint_enabled))
        return 'maint'
      return 'basic'
    },
    show_maint() {
      return this.vsm_mode !== 'basic'
    },
    dvir_combined() {
      return this.flag_enabled(this.summary.dvir_combined)
    },
    standaloneId() {
      return (this.summary && this.summary.vsm_standalone_uuid) || this.tenant_id
    },
    can_edit_wash_status() {
      const role = this.user && this.user.role
      return role !== 'dispatch' && role !== 'garage'
    },
    can_edit_maint_status() {
      const role = this.user && this.user.role
      return role !== 'dispatch' && role !== 'wash-bay'
    },
    visible_status_options() {
      // maint/dvir modes use the maint page's wash vocabulary (OOS lives on
      // the maint dimension there); basic mode mirrors vehicle_status_tbn
      if (this.show_maint) {
        return [
          { value: 'UNK', text: '' },
          { value: 'DIRTY', text: 'DIRTY' },
          { value: 'CLEANED', text: 'CLEAN' },
          { value: 'OUT', text: 'OUT' },
        ]
      }
      const options = [
        { value: 'READY', text: 'READY' },
        { value: 'CLEANED', text: 'CLEANED' },
        { value: 'WASHED', text: 'WASHED' },
        { value: 'DIRTY', text: 'DIRTY' },
        { value: 'OUT', text: 'OUT' },
        { value: 'OOS', text: 'OOS' },
      ]
      if (this.washed_enabled)
        return options
      return options.filter(item => item.value !== 'READY' && item.value !== 'WASHED')
    },
    maintenance_status_options() {
      if (this.vsm_mode === 'dvir') {
        return this.dvir_combined
          ? [
            { value: 'READY', text: 'READY' },
            { value: 'DVIR', text: 'DVIR' },
            { value: 'PM', text: 'PM' },
            { value: 'OOS', text: 'OOS' },
          ]
          : [
            { value: 'READY', text: 'READY' },
            { value: 'PENDING_DVIR', text: 'PENDING' },
            { value: 'UNSAFE_DVIR', text: 'UNSAFE' },
            { value: 'PM', text: 'PM' },
            { value: 'OOS', text: 'OOS' },
          ]
      }
      return [
        { value: 'READY', text: 'READY' },
        { value: 'PM', text: 'PM' },
        { value: 'OOS', text: 'OOS' },
      ]
    },
    card_rows() {
      return this.timeline_display_rows.map(row => ({ row, departure: this.cardNextDeparture(row) }))
    },
    standalone_href() {
      return './#/vsm-upcoming-tbn/reload/' + this.standaloneId
    },
    leading_columns() {
      // maint mode shows two selects side by side; the caret needs extra room
      return [{ key: 'status_chips', label: 'Status', width: this.show_maint ? '205px' : '128px' }]
    },
  },

  watch: {
    // App.vue reuses this instance across same-tab URL changes (chromed route
    // and standalone prefixes both mount this component) — re-derive the mode
    '$route'() {
      this.stopTimer()
      this.has_run = false
      this.check_features()
    },
    mobileView(isMobile) {
      // the hover panel has no dismiss affordance once the grid is gone
      if (isMobile) {
        this.booking_panel_visible = false
        this.booking_panel_details = []
      }
    },
    user: {
      deep: true,
      handler() {
        if (this.standalone)
          return
        this.has_run = false
        this.maybeAutoSearch()
      },
    },
    selected_base() {
      if (!this.standalone && this.has_run)
        this.load_data()
    },
    booking_filter() {
      if (this.has_run)
        this.scheduleFilterResultsLocal()
    },
    '$pageVisibility.hidden'(newVal, oldVal) {
      if (this.standalone && oldVal && !newVal)
        this.resetTimerAndReload()
    },
  },
}
</script>

<style scoped>
.vsm-unknown-base { border: 1px solid hsl(32, 82%, 48%); background-color: hsla(32,82%,56%,0.25); border-radius: 5px; padding: 6px 10px; margin-bottom: 10px; font-weight: bold }

.driver-actuals-timeframe {
  flex-shrink: 0;
}
/* ops_vsm pill shape; solid fills match the status colors used in the
   results rows */
.vsm-upcoming-chip {
  border: 1px solid grey;
  border-radius: 999px;
  padding: 3px 10px;
  font-size: 12.5px;
  font-weight: 600;
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
}
.vsm-upcoming-chip.selected {
  outline: 2px solid #333;
}
.vsm-upcoming-chip.total { background-color: transparent; }
.vsm-upcoming-chip.ready { background-color: hsla(120,100%,75%,0.3); }
.vsm-upcoming-chip.cleaned { background-color: hsla(190,70%,50%,0.4); }
.vsm-upcoming-chip.washed { background-color: hsla(160,30%,40%,0.4); }
.vsm-upcoming-chip.dirty { background-color: hsla(25,28%,23%,0.4); }
.vsm-upcoming-chip.out { background-color: hsla(290,60%,70%,0.3); }
.vsm-upcoming-chip.oos { background-color: hsla(357,78%,65%,0.4); }
.vsm-upcoming-chip.pm { background-color: hsla(210,100%,50%,0.4); }
.vsm-upcoming-chip.dvir { background-color: hsla(60,100%,50%,0.4); }
.vsm-upcoming-chip.unsafe-dvir { background-color: hsla(32,82%,56%,0.6); }
/* far right; half planned-blue, half service-red like the conflict bars */
.vsm-upcoming-chip.overlap {
  margin-left: auto;
  background-image: linear-gradient(
    to right,
    hsla(200, 40%, 55%, 0.65) 0,
    hsla(200, 40%, 55%, 0.65) 50%,
    hsla(357, 68%, 62%, 0.65) 50%,
    hsla(357, 68%, 62%, 0.65) 100%
  );
}
/* phones: sticky one-row swipe strip for the whole control/chip row
   (vsm_board's filter-bar pattern: hidden scrollbar, right fade, trailing
   spacer so the last chip can swipe clear of the fade) */
@media (max-width: 640px) {
  .vsm-upcoming-toolbar {
    position: sticky;
    /* the horizon shell's top nav is fixed; stick just below it */
    top: var(--fi-hz-top-offset, 52px);
    z-index: 20;
    background-color: var(--fi-surface, #fff);
    flex-wrap: nowrap;
    justify-content: flex-start;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;
    padding: 6px 4px;
    margin: 8px 0;
    mask-image: linear-gradient(to right, #000 calc(100% - 22px), transparent);
  }
  .vsm-upcoming-toolbar--standalone {
    /* no fixed nav on the chromeless board */
    top: 0;
  }
  .vsm-upcoming-toolbar::-webkit-scrollbar {
    display: none;
  }
  .vsm-upcoming-toolbar::after {
    content: '';
    flex: 0 0 28px;
  }
  .vsm-upcoming-toolbar > * {
    flex: 0 0 auto;
  }
  .vsm-upcoming-toolbar .toolbar-input {
    /* iOS focus-zoom dodge */
    font-size: 16px;
  }
  .vsm-upcoming-chip.overlap {
    margin-left: 8px;
  }
}
/* narrow-but-mouse devices: a hidden scrollbar strands a wheel-panned row,
   so revert the strip to wrapping (vsm_board's hover/pointer carve-out) */
@media (max-width: 640px) and (hover: hover) and (pointer: fine) {
  .vsm-upcoming-toolbar {
    flex-wrap: wrap;
    overflow-x: visible;
    mask-image: none;
  }
  .vsm-upcoming-toolbar::after {
    content: none;
  }
}
/* mobile card layout (replaces the timeline grid below 640px) */
.vsm-up-card-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.vsm-up-card {
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  padding: 8px 10px;
  background-color: var(--fi-surface, #fff);
}
.vsm-up-card-head {
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: bold;
  font-size: 15px;
}
.vsm-up-card-depart {
  margin-left: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  line-height: 1.15;
}
.vsm-up-card-depart-delta {
  font-size: 13px;
}
.vsm-up-card-depart-time {
  font-size: 11px;
  font-weight: normal;
  color: #6c757d;
}
.vsm-up-card-item {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 2px 8px;
  margin-top: 6px;
  padding: 4px 0 4px 8px;
  border-left: 4px solid hsl(200, 40%, 55%);
  font-size: 13px;
}
.vsm-up-card-item--service {
  border-left-color: hsl(357, 68%, 62%);
}
.vsm-up-card-item--overlap {
  border-image: repeating-linear-gradient(
    to bottom,
    hsl(200, 40%, 55%) 0,
    hsl(200, 40%, 55%) 6px,
    hsl(357, 68%, 62%) 6px,
    hsl(357, 68%, 62%) 12px
  ) 1;
}
.vsm-up-card-time {
  font-weight: 600;
}
.vsm-up-card-meta {
  color: #6c757d;
}
</style>

<!-- unscoped: these classes land on chips rendered inside driver_actuals_timeline_table -->
<style>
.vsm-up-mini-chip {
  display: inline-block;
  vertical-align: middle;
  font-size: 11px;
  font-weight: bold;
  border: 1px solid grey;
  border-radius: 4px;
  padding: 1px 4px;
  margin-left: 2px;
}
.driver-actuals-leading-cell .vsm-up-mini-chip:first-child {
  margin-left: 0;
}
/* mobile: slim the page header down to reclaim vertical space (!important
   outranks fi_page_rail's scoped rules regardless of bundle order) */
.vsm-upcoming-rail--mobile.fi-pr-rail {
  padding: 2px 10px !important;
  margin-bottom: 4px !important;
}
.vsm-upcoming-rail--mobile .fi-pr-title {
  font-size: 15px !important;
}
/* fi_page_rail's narrow-viewport rule wraps the actions onto a full-width
   second row; these headers keep everything on one line (the row would be
   blank on pages whose action buttons all hide on mobile) */
.vsm-upcoming-rail--mobile .fi-pr-actions {
  width: auto !important;
}
.vsm-upcoming-rail--mobile.fi-pr-legacy {
  padding: 2px !important;
  margin-bottom: 5px !important;
}
.vsm-upcoming-rail--mobile .fi-pr-legacy-title {
  font-size: 16px !important;
}
/* the action buttons (info, print) shrink with the compact mobile header */
.vsm-upcoming-rail--mobile .fi-pr-actions .btn,
.vsm-upcoming-rail--mobile .fi-pr-legacy-actions .btn {
  padding: 2px 8px !important;
  font-size: 12px !important;
  line-height: 1.3 !important;
}
/* editable variant of the mini chip: a compact select whose background
   carries the same status color classes (caret comes from custom-select) */
.vsm-up-chip-select.custom-select {
  display: inline-block;
  width: auto;
  height: auto;
  font-size: 12px;
  font-weight: bold;
  border: 1px solid grey;
  border-radius: 4px;
  /* wide right padding keeps the caret clear of the status text */
  padding: 2px 28px 2px 6px;
  line-height: 1.3;
  vertical-align: middle;
  margin-left: 2px;
}
.driver-actuals-leading-cell .vsm-up-chip-select:first-child {
  margin-left: 0;
}
/* legacy VSM tables: one uniform text size across every column, scaling
   with the viewport (fixed px overrides the table's inline tenant
   font_size; !important reaches the inputs' inline font-size styles) */
td.vsm-dt-cell {
  white-space: nowrap;
}
.vsm-status-table th,
.vsm-status-table td {
  /* proportional to the table's inline tenant font_size (default 18-22px),
     so tenant-tuned sizing carries through instead of a fixed px cap */
  font-size: 0.8em;
}
.vsm-status-table td .form-control {
  /* match the cell text (outranks the inputs' inline font-size styles) */
  font-size: inherit !important;
}
@media (min-width: 1200px) {
  .vsm-status-table th,
  .vsm-status-table td { font-size: 0.85em; }
  .vsm-status-select.custom-select {
    font-size: 13.5px;
    padding-top: 4px;
    padding-bottom: 4px;
  }
}
@media (min-width: 1600px) {
  .vsm-status-table th,
  .vsm-status-table td { font-size: 0.9em; }
  .vsm-status-select.custom-select {
    font-size: 15px;
    padding: 5px 30px 5px 8px;
  }
}
/* breathing room between the wash and maint controls in the Status column */
.driver-actuals-leading-cell .vsm-up-chip-select + .vsm-up-chip-select,
.driver-actuals-leading-cell .vsm-up-chip-select + .vsm-up-mini-chip,
.driver-actuals-leading-cell .vsm-up-mini-chip + .vsm-up-chip-select {
  margin-left: 6px;
}
.driver-actuals-leading-cell {
  padding: 0 2px;
}
.vsm-up-cell-ready { background-color: hsla(120,100%,75%,0.3); }
.vsm-up-cell-cleaned { background-color: hsla(190,70%,50%,0.4); }
.vsm-up-cell-washed { background-color: hsla(160,30%,40%,0.4); }
.vsm-up-cell-dirty { background-color: hsla(25,28%,23%,0.4); }
.vsm-up-cell-out { background-color: hsla(290,60%,70%,0.3); }
.vsm-up-cell-oos { background-color: hsla(357,78%,65%,0.4); }
.vsm-up-cell-maint-ready { background-color: hsla(120,100%,75%,0.3); }
.vsm-up-cell-maint-pm { background-color: hsla(210,100%,50%,0.4); }
.vsm-up-cell-maint-oos { background-color: hsla(357,78%,65%,0.4); }
.vsm-up-cell-maint-dvir { background-color: hsla(60,100%,50%,0.4); }
.vsm-up-cell-maint-pending_dvir { background-color: hsla(60,100%,50%,0.4); }
.vsm-up-cell-maint-unsafe_dvir { background-color: hsla(32,82%,56%,0.6); }
/* the select variants need !important: bootstrap's .custom-select sets
   background via the shorthand (white + caret) and the midnight skin re-inks
   custom-selects to a dark field — both outrank a bare color class */
select.custom-select.vsm-up-cell-ready { background-color: rgb(217, 255, 217) !important; }  /* hsla(120,100%,75%,.3) on white */
select.custom-select.vsm-up-cell-cleaned { background-color: rgb(168, 228, 240) !important; }
select.custom-select.vsm-up-cell-washed { background-color: rgb(181, 206, 198) !important; }
select.custom-select.vsm-up-cell-dirty { background-color: rgb(183, 175, 170) !important; }
select.custom-select.vsm-up-cell-out { background-color: rgb(241, 215, 246) !important; }
select.custom-select.vsm-up-cell-oos { background-color: rgb(247, 191, 194) !important; }
select.custom-select.vsm-up-cell-maint-ready { background-color: rgb(217, 255, 217) !important; }
select.custom-select.vsm-up-cell-maint-pm { background-color: rgb(153, 204, 255) !important; }
select.custom-select.vsm-up-cell-maint-oos { background-color: rgb(247, 191, 194) !important; }
select.custom-select.vsm-up-cell-maint-dvir { background-color: rgb(255, 255, 153) !important; }
select.custom-select.vsm-up-cell-maint-pending_dvir { background-color: rgb(255, 255, 153) !important; }
select.custom-select.vsm-up-cell-maint-unsafe_dvir { background-color: rgb(243, 191, 133) !important; }
</style>
